module.exports = __webpack_public_path__ + "client/img/boss_03.970a74d0.png";